import { ReactNode, useEffect } from "react";

export const TitledPage = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return children;
};
